import { PET_ITEM } from "@src/mock/data/pet";

export default {
  title: '刪除會員寵物',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": PET_ITEM,
        }
      }
    },
  ]
}
